import React from 'react';
import classnames from 'classnames';
import { dfs, dateTypes } from '../../utils';
import { Tooltip } from '@platform/base';

const FLAG_SORT_ASC = 1;
const FLAG_SORT_DESC = -1;
//判断字符是否为中文
function isChinese(char) {
    if (typeof char === "string") {
        char = char.slice(0, 1);
        return /^[\u4E00-\u9FA5]$/.test(char);
    }
}
export const DEFAULT_SORTER = (col, a, b) => {
    const aValue = a.values[col.key];
    const bValue = b.values[col.key];
    if (col.itemtype === 'number') {
        return (aValue?.value ?? '') - (bValue?.value ?? '');
    } else if (dateTypes.has(col.itemtype)) {
        // （暂时弃用）value带时分秒， display不带，组合排序会有问题。 先用display
        // YBP-CCF-BUG-3290
        let aDateString = aValue?.value || '', 
            bDateString = bValue?.value || '';
        return aDateString.localeCompare(bDateString);
    } else if (col.itemtype === 'attachment') {
        let aNum = aValue?.value?.split(',')[0] || '',
            bNum = bValue?.value?.split(',')[0] || '';
        return aNum - bNum;
    } else {
        let aDisplay = aValue?._display_ ?? '';
        let bDisplay = bValue?._display_ ?? '';
        //按首字母排序
        if (isChinese(aDisplay) && isChinese(bDisplay)) {
            return aDisplay.localeCompare(bDisplay);
        }
        if (aDisplay > bDisplay) {
            return 1;
        } else if (aDisplay < bDisplay) {
            return -1;
        } else {
            return 0;
        }
        // aDisplay = aDisplay.toString();
        // bDisplay = bDisplay.toString();
        // return aDisplay.localeCompare(bDisplay);
        // if (aDisplay > bDisplay) {
        //     return 1;
        // } else if (aDisplay < bDisplay) {
        //     return -1;
        // } else {
        //     return 0;
        // }
    }
};

export default function useSort(Table) {
    return class SortTable extends React.Component {
        render() {
            let { sortConfig = {}, columns = [], locale, layoutMode } = this.props,
                { enable, orders = new Map() } = sortConfig;

            if (enable) {
                columns = dfs(columns, col => {
                    if (col.children || !col.sortable || (layoutMode === "flat" && col.isChildCol)) {
                        return col;
                    }

                    return {
                        ...col,
                        title: (
                            <>
                                {col.title}
                                <Tooltip
                                    placement="top"
                                    overlay={locale['table0041']}
                                    delayShow={300}
                                >
                                    <i
                                        fieldid={'header-sort-icon-asc'}
                                        className={classnames("header-icon sort-icon", { 'sort-icon-fixed': orders.get(col.key) === FLAG_SORT_ASC })}
                                        onClick={() => this.handleSortIconClick(col, FLAG_SORT_ASC)}
                                    >
                                        <i
                                            className={classnames(
                                                "iconfont icon-a-liebiao-shengxu1x",
                                                // { active: orders.get(col.key) === FLAG_SORT_ASC },
                                            )}
                                        />
                                    </i>
                                    <i
                                        fieldid={'header-sort-icon-desc'}
                                        className={classnames("header-icon sort-icon", { 'sort-icon-fixed': orders.get(col.key) === FLAG_SORT_DESC })}
                                        onClick={() => this.handleSortIconClick(col, FLAG_SORT_DESC)}
                                    >
                                        <i
                                            className={classnames(
                                                "iconfont icon-a-liebiao-jiangxu1x",
                                                // { active: orders.get(col.key) === FLAG_SORT_DESC },
                                            )}
                                        />
                                    </i>
                                </Tooltip>
                            </>
                        ),
                        sorter: col.sorter || DEFAULT_SORTER.bind(null, col),
                    };
                });
            }

            return (
                enable
                    ?
                    <Table
                        {...this.props}
                        columns={columns}
                        sortConfig={{
                            ...sortConfig,
                            onSortClick: this.handleSortIconClick,
                        }}
                    />
                    :
                    <Table {...this.props} />
            );
        }

        handleSortIconClick = (col, order) => {
            let { sortConfig = {} } = this.props,
                { orders = new Map(), onSort } = sortConfig,
                colKey = col.key;

            if (orders.get(colKey) === order) {
                return; // 屏蔽再次点击取消排序的功能
                // 取消已有排序状态
                // orders.delete(colKey);
            } else {
                // 新增排序状态  TODO 以后改成可配的，现在只支持一个排序
                orders.clear();
                orders.set(colKey, order);
            }

            onSort?.(orders);
        }
    };
}

useSort.displayName = 'useSort';
useSort.dependence = [];
useSort.hooks = function () {
    this._sort = rowKeys => {
        let orders = this.store.sortInfo,
            visibleRowKeysSet = new Set(rowKeys),
            { sort } = this.getConfig() || {};
            
        if (!orders?.size) { return rowKeys; }
        this.clearGroupSortInfo(); //清空组合排序

        if (typeof sort?.sortFun === 'function') {
            let sortInfo = [...this.getSortInfo()].map(([colKey, order], index) => {
                return {
                    order: order === 1 ? "ascend" : "descend",
                    field: colKey,
                    orderNum: index,
                };
            });
            sort.sortFun(sortInfo, this.getVisibleRows());
            return rowKeys;
        }

        rowKeys = [...rowKeys];
        [...orders].forEach(([colKey, order]) => {
            // 单来源，取主的sorter
            let mainCol;

            try {
                if (this.getRelation) {
                    let id = this.store.meta.mainId,
                        relation = this.getRelation(),
                        mainId = relation.main[id];

                    mainCol = this.store.meta[mainId].items.find(e => e.attrcode === colKey);
                }
            } catch (e) {
                console.error(e);
            }

            let col = this.getColumnProps(colKey);
            let sorter = col.sorter || mainCol?.sorter || DEFAULT_SORTER.bind(null, col);

            rowKeys.sort((rowAKey, rowBKey) => {
                let rowAData = this.getRowData(rowAKey),
                    rowBData = this.getRowData(rowBKey);

                return order === FLAG_SORT_ASC ? sorter(rowAData, rowBData) : sorter(rowBData, rowAData);
            });

            this.store.rowKeys.sort((rowAKey, rowBKey) => {
                let rowAData = this.getRowData(rowAKey),
                    rowBData = this.getRowData(rowBKey);

                if (!visibleRowKeysSet.has(rowAKey) || !visibleRowKeysSet.has(rowBKey)) {
                    return 0;
                }

                return order === FLAG_SORT_ASC ? sorter(rowAData, rowBData) : sorter(rowBData, rowAData);
            });

            // 同步至其他页签
            try {
                if (this.getRelation && this.getPageScope()) {
                    let id = this.store.meta.mainId,
                        relation = this.getRelation(),
                        pageScope = this.getPageScope(),
                        share = relation.share[id];

                    share.forEach(shareId => {
                        if (shareId === id) {
                            return;
                        }

                        /**
                         * 单来源多页签时，要把当前的排序结果同步给其他页签，具体为：
                         * 1、同步sortInfo
                         * 2、同步visibleRowKeys
                         * 3、同步rowKeys
                         * 4、调用_updateDataIndex
                         * 5、调用_updateViewIndex和updateRowsHeight
                         * 
                         * 其中：
                         * 1是模拟setSortInfo
                         * 234是模拟_sort
                         * 5是模拟_updateVisibleRows
                         */

                        let instance = pageScope.cardTableDataSource[shareId].getInstance();

                        instance.store.sortInfo = orders;
                        instance.store.groupSortInfo = [];
                        instance.store.visibleRowKeys = [...rowKeys];
                        instance.store.rowKeys = [...this.store.rowKeys];
                        instance._updateDataIndex();
                        instance.updateRowsHeight({ shouldUpdate: false });
                    });
                }
            } catch (e) {
                console.error(e);
            }
        });

        this._updateDataIndex();
        return rowKeys;
    };
    return {
        getSortInfo: () => {
            return this.store.sortInfo || new Map();
        },
        setSortInfo: (orders, { shouldUpdateRows = true } = {}) => {
            this.store.sortInfo = orders || new Map();
            this.store.groupSortInfo = [];

            shouldUpdateRows && this._updateVisibleRows();
            this.forceUpdate();
        },
        clearSortInfo: () => {
            this.store.sortInfo = new Map();
        },
    };
};
useSort.propsGenerator = function (props) {
    if (!props.sortConfig?.enable) {
        return props;
    }

    let { store, sortConfig } = props;

    return {
        ...props,
        sortConfig: {
            ...sortConfig,
            orders: store.getSortInfo(),
            onSort: orders => {
                store.setSortInfo(orders);
                sortConfig?.onSort?.(orders);
            },
        },
    };
};
